import TypesAdmin from '@/modules/typeadmin/views/TypesAdmin';
// import { ROLE_USER, ROLE_ADMIN, ROUTE_LOGIN } from '@/router/default-roles';

export default [
	{
		path: '/typesadmin/:type',
		name: 'typesadmin',
		component: TypesAdmin,
		meta: {
			/*permissions: [ 
				{
					role: ROLE_ADMIN,
					access: false,
					redirect: '/'
				},
			],*/
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	
]